import { APP_NAME } from './appConfig';

export const companyInfo = {
  name: APP_NAME,
  tagline: "Quick, Reliable, Affordable Delivery",
  address: "123 Commerce Street, Mumbai, Maharashtra 400001, India",
  phone: "+91-1800-123-4567",
  email: "support@redgaady.com",
  hours: "Available 24/7",
  about:
    `${APP_NAME} is a leading last-mile delivery service provider in India, connecting businesses and individuals with reliable, fast, and affordable delivery solutions.`,
  description:
    "We provide same-day and next-day delivery services across Mumbai with multiple vehicle options to suit your needs.",
};

/**
 * Vehicle Types & Pricing
 * Formula: baseFare + (distance * costPerKm) + platformFee + GST
 */
export const vehicleTypes = {
  BIKE: {
    id: "BIKE",
    name: "Bike",
    icon: "🏍️",
    capacity: "2-5 kg",
    description: "Lightweight packages and documents",
    baseFare: 30, // Base fare in rupees
    costPerKm: 8, // Cost per km in rupees
    avgSpeed: "30 km/h", // Average delivery speed
    timeEstimate: "Variable based on distance",
    maxDistance: 20, // Max delivery distance
    color: "#FF6B6B",
  },
  SCOOTER: {
    id: "SCOOTER",
    name: "Scooter",
    icon: "🛵",
    capacity: "5-15 kg",
    description: "Small to medium packages",
    baseFare: 50,
    costPerKm: 10,
    avgSpeed: "25 km/h",
    timeEstimate: "Variable based on distance",
    maxDistance: 25,
    color: "#4ECDC4",
  },
  CAR: {
    id: "CAR",
    name: "Car",
    icon: "🚗",
    capacity: "15-50 kg",
    description: "Medium to large packages",
    baseFare: 80,
    costPerKm: 12,
    avgSpeed: "40 km/h",
    timeEstimate: "Variable based on distance",
    maxDistance: 50,
    color: "#45B7D1",
  },
  TRUCK: {
    id: "TRUCK",
    name: "Truck",
    icon: "🚚",
    capacity: "100+ kg",
    description: "Bulk or heavy shipments",
    baseFare: 150,
    costPerKm: 15,
    avgSpeed: "35 km/h",
    timeEstimate: "Variable based on distance",
    maxDistance: 100,
    color: "#96CEB4",
  },
};

/**
 * Pricing Configuration
 */
export const pricingConfig = {
  platformFee: 10, // Fixed platform fee in rupees
  gstRate: 0.05, // 5% GST
  minFare: 40, // Minimum delivery charge
  surgeChargeActive: false, // Peak hour surge pricing
  surgeMultiplier: 1.5, // Apply if surgeChargeActive is true
};

/**
 * Service Areas (Mock)
 */
export const serviceAreas = [
  { name: "Downtown", lat: 19.0176, lng: 72.8479 },
  { name: "Bandra", lat: 19.0596, lng: 72.8295 },
  { name: "Andheri", lat: 19.1136, lng: 72.8697 },
  { name: "Dadar", lat: 19.0176, lng: 72.8479 },
  { name: "Powai", lat: 19.0745, lng: 72.9042 },
  { name: "Thane", lat: 19.2183, lng: 72.9781 },
];

const companyConfig = {
  companyInfo,
  vehicleTypes,
  pricingConfig,
  serviceAreas,
};

export default companyConfig;
